export default {
  getId: (state) => {
    return state.id
  },
  getStatus: (state) => {
    return state.status
  },
}
